var dogCatSelection,wetDrySelection,productSelection;
//  Only for mix products
var isProductAdded = 
{
    wet: false,
    dry: false
}

function SearchParentsFor(start, cls, top) {
    var result;

    var parent = start.parentNode;
    if ((parent) && (parent.getAttribute)) {
        var pcls = parent.getAttribute("class");
        if (pcls) {
            var pclsArray = pcls.split(" ");
            for (var i = 0; i < pclsArray.length; i++) {
                if (pclsArray[i] == cls) {
                    result = parent;
                    break;
                }
            }
        }

        if ((!result) && ((!top) || (parent != top))) {
            result = SearchParentsFor(parent, cls, top);
        }
    }

    return (result);
}

function listenSlideNavigationButton() 
{
    var navigationButtons = document.querySelectorAll( '.navigationButton' );
    navigationButtons.forEach( function( navigationButton )
    {
        navigationButton.addEventListener( 'click' , function( button )
        {
            var weightElement     = document.querySelector( ".select_weight:not( .hidden * )" );
            var weight            = weightElement.value;
            var container         = weightElement.closest( ".scrumbles-sub-content-row-desktop" ).parentNode;
            var error             = container.querySelector( ".error-message" );
            var selected_activity = container.querySelector( ".pet_block_option.active" );
            var parent = navigationButton.closest( ".feeding_calculator_wrapper" );
            if (navigationButton.dataset.go_to == 'food_type') 
            {
                document.getElementById( "feeding-calc-layer-3-inner" ).classList.add( 'active' );
                document.getElementById( "feeding-calc-layer-3-inner" ).classList.remove( 'hidden' );
                document.getElementById( "feeding-calc-custom-mix-ranger-id" ).classList.remove( 'active' );
                document.getElementById( "feeding-calc-custom-mix-ranger-id" ).classList.add( 'hidden' );
                document.querySelector( "#feeding-calc-layer-3 .range_navigationButton" ).setAttribute("data-go_to", "layer_2");
                document.querySelector( "#feeding-calc-layer-3 .range_navigationButton" ).style.margin = "40px 0 0";
            }
            else
            {
                var applyValidation = true;
                if ( navigationButton.classList.contains( "goback" ) )
                {
                    applyValidation = false;
                }
                
                var go_to_slide = parent.querySelector( '.' + navigationButton.dataset.go_to);
                if ( ( applyValidation ) && ( weight == "" ) )
                {
                    error.style.display = "block";
                    return false;
                }
                else if ( ( applyValidation ) && ( selected_activity == null ) )
                {
                    var activity_wrapper = container.querySelector( ".active_pet" );
                    var error_message = activity_wrapper.querySelector( '.error-message' );
                    error_message.style.display="block";
                    return false;
                }
                else
                {
                    if( navigationButton.dataset.go_to.includes( "slide" ) )
                    {
                        var all_calculator_boxes =  document.querySelectorAll( '.calculator_box' );
                        all_calculator_boxes.forEach( function( calculator_box )
                        {
                            calculator_box.classList.remove( 'active' );
                        });
                        go_to_slide.classList.add( 'active' );
                    }
                    else if( navigationButton.dataset.go_to.includes( "layer" ) )
                    {
                        if( navigationButton.classList.contains( "combination-return-button" ) && wetDrySelection.includes( "mix" ) )
                        {
                            if( document.getElementById( "feeding-calc-option-row-options-dry-cat" ).classList.contains( "hidden" ) == false )
                            {
                                document.getElementById( "feeding-calc-option-row-options-dry-cat" ).classList.add( "hidden" );
                                document.getElementById( "feeding-calc-option-row-options-wet-cat" ).classList.remove( "hidden" );
                            }
                            else if( document.getElementById( "feeding-calc-option-row-options-dry-dog" ).classList.contains( "hidden" ) == false )
                            {
                                document.getElementById( "feeding-calc-option-row-options-dry-dog" ).classList.add( "hidden" );
                                document.getElementById( "feeding-calc-option-row-options-wet-dog" ).classList.remove( "hidden" );
                            }
                            else
                            {
                                $(".active-feeding-calc-layer").removeClass("active-feeding-calc-layer");
                                go_to_slide.classList.add( 'active-feeding-calc-layer' );
                            }
                        }
                        else
                        {
                            $(".active-feeding-calc-layer").removeClass("active-feeding-calc-layer");
                            go_to_slide.classList.add( 'active-feeding-calc-layer' );
                        }

                    }
                }
            }
            ReslickVisibleProductSlider( );
        } );

    });


    var weight_boxes = document.querySelectorAll( ".select_weight" );
    weight_boxes.forEach( function( weight_box )
    {
        weight_box.addEventListener( 'change' , () => 
        {
            var weight_parent = SearchParentsFor( weight_box, "weight_content_wraper" );
            var error_message = weight_parent.querySelector( '.error-message' );
            error_message.style.display = "none";
        });
    } );
}

function HandleRadioChange( e )
{
    var set_option            = e.currentTarget;
    var all_pet_block_options = set_option.closest( ".active_pet" ).querySelectorAll( '.pet_block_option' );

    all_pet_block_options.forEach( function( all_pet_block_option )
    {
        all_pet_block_option.classList.remove( 'active' );
    });
    set_option.classList.add( 'active' );
    set_option.querySelector( "input" ).checked = true;

    var activity_parent = SearchParentsFor(set_option, "active_pet");
    var error_message = activity_parent.querySelector('.error-message');
    error_message.style.display="none";

}

function listenOptionChange( pet_block_option ) 
{
    pet_block_option.addEventListener( "click", HandleRadioChange );
}

function listenSubscriptionButton( event ) 
{
    var container = event.target.closest( '.subscription_box' );
    var all_subscription_box_options =  container.querySelectorAll( '.subscription_box_option' );
    all_subscription_box_options.forEach( function( all_subscription_box_option )
    {
        all_subscription_box_option.classList.remove( 'option--active' );
    });

    var parent = SearchParentsFor( event.target, "subscription_box_option" );
    parent.classList.add( 'option--active' );

    if (  parent.getAttribute( "data-sub-id" ) == 'onetime_option') 
    {
        var weekSelectBox = parent.querySelector( '.selling_plan_all_groups' );
        var error_message = parent.querySelector( '.error_message' );  
        if ( error_message ) 
        {                    
            weekSelectBox.classList.remove("error");
            error_message.remove();
        }
    }
}


function GetProductData( element )
{
    var productData;
    var pid = element.getAttribute( "data-pid" );
    if ( pid )
    {
        for ( var i = 0; i < g_feedingCalculatorProducts.length; i++ )
        {
            if ( g_feedingCalculatorProducts[ i ].id == pid )
            {
                productData = g_feedingCalculatorProducts[ i ];
                break;
            }
        }
    }
    return ( productData );
}

function formatAsCurrency( amount ) 
{
    var decimalAmount = parseFloat( amount ) / 100;
    var formattedAmount = new Intl.NumberFormat( 'en-GB', 
    {
        style: 'currency',
        currency: 'GBP'
    } ).format( decimalAmount );

    return formattedAmount;
}

function SetupProduct( root, productData )
{
    var img = root.querySelector( "img" );
    img.setAttribute( "src", productData.imageURL );
    img.setAttribute( "alt", productData.title );

    root.querySelector( ".product_title" ).innerText = productData.title;

    document.querySelector( 'input[name="foodCategory"]' ).value                     = productData.category;
    document.querySelector( 'input[name="foodType"]' ).value                         = productData.foodType;
    document.querySelector( 'input[name="flavourCalories"]' ).value                  = productData.calorieDensity;
    document.querySelector( '.cart-added-pop-up .cart-added-popup-title' ).innerText = productData.title;

    var planSelector = root.querySelector( ".subscription_box .selling_plan_all_groups" );
    var idx          = 0;

    while ( idx < planSelector.options.length )
    {
        if ( planSelector.options[ idx ].value ) // don't remove the "select frequency" option
        {
            planSelector.options[ idx ].remove( );
        }
        else
        {
            idx++;
        }
    }
    for ( var i = 0; i < productData.plans.length; i++ )
    {
        var plan = productData.plans[ i ];

        for ( var j = 0; j < plan.selling_plans.length; j++ )
        {
            var sellingPlan = plan.selling_plans[ j ];
            var option      = document.createElement( "option" );

            option.value = sellingPlan.id;
            option.setAttribute( "data-plan-index", i );
            if( sellingPlan.name.includes( "weeks" ) )
            {
                var weeks = sellingPlan.name.split( " " )[ 1 ];
            }
            option.setAttribute( "data-plan-weeks", weeks );
            option.appendChild( document.createTextNode( sellingPlan.name ) );

            planSelector.appendChild( option );
        }
    }

    var radios = root.querySelectorAll( ".selling_plan_radio" );
    radios.forEach( function( radio )
    {
        var label = radio.closest( '.selling_plan_label' );
        radio.name = "selling_plan--" + productData.id;
        if( radio.id.includes('subSave') )
        {
            radio.id = "subSave--" + productData.id;
            label.setAttribute( "for", "subSave--" + productData.id );
        }
        else if( radio.id.includes('onetime') )
        {
            radio.id = "onetime--" + productData.id;
            label.setAttribute( "for", "onetime--" + productData.id );
        }
    });

    var variantSelector = root.querySelector( ".variant_list select" );

    while ( variantSelector.firstChild )
    {
        variantSelector.firstChild.remove( );
    }

    var firstCheck = true;

    productData.variants.forEach( function( variant )
    {
        var option = document.createElement( "option" );

        option.value = variant.id;
        option.setAttribute( "data-var-id", variant.id );
        option.setAttribute( "data-variant-data", JSON.stringify( variant.detail ) );
        option.setAttribute( "data-originalprice", variant.price );
        option.setAttribute( "data-subsave_price", variant.subsave_price );
        option.setAttribute( "data-discounted_price", variant.discounted_price );
        option.setAttribute( "data-title", productData.title + " " + variant.title );

        if( variant.plans )
        {
            for ( var i = 0; i < variant.plans.length; i++ )
            {
                option.setAttribute( "data-sub-plan-id-" + i, variant.plans[ i ].planID );
            }
        }

        option.appendChild( document.createTextNode( variant.title ) );

        variantSelector.appendChild( option );

        if(firstCheck)
        {
            $(variantSelector).selectedIndex = 0;
            updatePriceDisplay();
            // variantSelector.value = option;
        }
        else
        {
            firstCheck = false;
        }

    } );
    variantSelector.selectedIndex = variantSelector.options.length - 1;
    variantSelector.dispatchEvent( new Event( "change" ) );
    function updatePriceDisplay( ) 
    {
        var priceOutput = root.querySelector( "#priceOutput" );
        var subSavePriceOutput = root.querySelector( "#subSavePriceOutput" );


        var initialOption = variantSelector.options[ variantSelector.selectedIndex ];
        var initialPrice = initialOption.getAttribute( "data-originalprice" );
        var initialSubSavePrice = initialOption.getAttribute( "data-subsave_price" );

        priceOutput.innerText = formatAsCurrency( initialPrice );
        subSavePriceOutput.innerText = formatAsCurrency( initialSubSavePrice );

        variantSelector.addEventListener( "change", function ( ) 
        {
            var selectedOption = variantSelector.options[ variantSelector.selectedIndex ];
            var selectedPrice = selectedOption.getAttribute( "data-originalprice" );
            var selectedSubSavePrice = selectedOption.getAttribute( "data-subsave_price" );

            priceOutput.innerText = formatAsCurrency( selectedPrice );
            subSavePriceOutput.innerText = formatAsCurrency( selectedSubSavePrice );
        });

        variantSelector.removeEventListener( "change", updatePriceDisplay );
        variantSelector.addEventListener( "change", updatePriceDisplay );
    }
}

function SpecialiseCalculatorForProduct( element )
{
    var light = element.getAttribute( "data-light" );
    var dark  = element.getAttribute( "data-dark" );

    if ( ( light ) && ( dark ) )
    {
        var style = document.getElementById( "feeding-calc-product-styles" );
        if (style) {
            
            style.innerText =
                             `
                             :root
            {
                --product-light-colour: ${light};
                --product-dark-colour: ${dark};
            }
            `;
        }
    }

    var productData = GetProductData( element );

    if ( productData )
    {
        var pd = document.querySelector( ".product_data_inner" );
        SetupProduct( pd, productData );
    }
    else
    {
        console.log( "error : selected product not found !" );
    }
}

function SpecialiseCalculatorForPetType( petType )
{
    var elements = document.querySelectorAll( "[data-pet-type]" );
    elements.forEach( function( element )
    {
        if ( element.getAttribute( "data-pet-type" ) == petType )
        {
            element.classList.remove( "hidden" );
        }
        else
        {
            element.classList.add( "hidden" );
        }
    } );
}

function getTreats()
{
    var seniorCheckbox = $('input[name="treats"]:checked')

    if(seniorCheckbox[0])
    {
        return true;
    }
    else
    {
        return false;
    }
}

function ReslickVisibleProductSlider( )
{
    var slider = document.querySelector( ".feeding-calc-option-row-product-options:not( .hidden )" );
    var product_count = $( ".calculator_product_selector", $(slider) ).length;
    if (product_count > 1) 
    {
        if( $(slider).hasClass("slick-initialized") )
        {
            $(slider).removeClass("hidden");
            $(slider).slick( "unslick");
        }

        $(slider).slick({
slidesToShow: 3,
slidesToScroll: 1,
dots: false,
swipeToSlide:true,
arrows: true,
                        // centerMode: true,
autoplay: false,
nextArrow: '<button class="next"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                      '<path d="M100.707 8.45711C101.098 8.06658 101.098 7.43342 100.707 7.04289L94.3431 0.678932C93.9526 0.288408 93.3195 0.288408 92.9289 0.678932C92.5384 1.06946 92.5384 1.70262 92.9289 2.09315L98.5858 7.75L92.9289 13.4069C92.5384 13.7974 92.5384 14.4305 92.9289 14.8211C93.3195 15.2116 93.9526 15.2116 94.3431 14.8211L100.707 8.45711ZM0 8.75H100V6.75H0V8.75Z" fill="#8D3F2B"/>'+
                      '</svg></button>',
prevArrow: '<button class="prev"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                      '<path d="M0.292892 7.04289C-0.0976334 7.43342 -0.0976334 8.06658 0.292892 8.45711L6.65685 14.8211C7.04738 15.2116 7.68054 15.2116 8.07107 14.8211C8.46159 14.4305 8.46159 13.7974 8.07107 13.4069L2.41422 7.75L8.07107 2.09315C8.46159 1.70262 8.46159 1.06946 8.07107 0.678932C7.68054 0.288408 7.04738 0.288408 6.65685 0.678932L0.292892 7.04289ZM101 6.75L1 6.75V8.75L101 8.75V6.75Z" fill="#8D3F2B"/>'+
                      '</svg></button>',
responsive: [
              {
breakpoint: 1024,
settings: {
slidesToShow: 2,
slidesToScroll: 1
            }
              },
              {
breakpoint: 768,
settings: {
slidesToShow: 3,
slidesToScroll: 1
            }
              },
              {
breakpoint: 480,
settings: {
slidesToShow: 1,
slidesToScroll: 1
            }
              }
              ]
        });

        $(slider).removeClass("hidden");
        setTimeout(() => {
            $( " .calculator_product_selector", slider ).css("visibility", "visible");
        }, 100);
    }
    else
    {
        $(" .calculator_product_selector", slider).css("visibility", "visible");
        $(slider).removeClass("hidden");
    }

}

function ReslickOneProductSlider( petType, foodType )
{
    var idToShow = `#feeding-calc-option-row-options-${foodType}-${petType}`;
    
    var product_count = $( idToShow + ' .calculator_product_selector' ).length;
    if (product_count > 3) 
    {
        var slider = $(idToShow);

        if( slider.hasClass("slick-initialized") )
        {
            slider.removeClass("hidden");
            slider.slick( "unslick");
        }

        slider.slick({
slidesToShow: 3,
slidesToScroll: 1,
dots: false,
swipeToSlide:true,
arrows: true,
                        // centerMode: true,
autoplay: false,
nextArrow: '<button class="next"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                      '<path d="M100.707 8.45711C101.098 8.06658 101.098 7.43342 100.707 7.04289L94.3431 0.678932C93.9526 0.288408 93.3195 0.288408 92.9289 0.678932C92.5384 1.06946 92.5384 1.70262 92.9289 2.09315L98.5858 7.75L92.9289 13.4069C92.5384 13.7974 92.5384 14.4305 92.9289 14.8211C93.3195 15.2116 93.9526 15.2116 94.3431 14.8211L100.707 8.45711ZM0 8.75H100V6.75H0V8.75Z" fill="#8D3F2B"/>'+
                      '</svg></button>',
prevArrow: '<button class="prev"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                      '<path d="M0.292892 7.04289C-0.0976334 7.43342 -0.0976334 8.06658 0.292892 8.45711L6.65685 14.8211C7.04738 15.2116 7.68054 15.2116 8.07107 14.8211C8.46159 14.4305 8.46159 13.7974 8.07107 13.4069L2.41422 7.75L8.07107 2.09315C8.46159 1.70262 8.46159 1.06946 8.07107 0.678932C7.68054 0.288408 7.04738 0.288408 6.65685 0.678932L0.292892 7.04289ZM101 6.75L1 6.75V8.75L101 8.75V6.75Z" fill="#8D3F2B"/>'+
                      '</svg></button>',
responsive: [
              {
breakpoint: 1024,
settings: {
slidesToShow: 2,
slidesToScroll: 1
            }
              },
              {
breakpoint: 768,
settings: {
slidesToShow: 3,
slidesToScroll: 1
            }
              },
              {
breakpoint: 480,
settings: {
slidesToShow: 1,
slidesToScroll: 1
            }
              }
              ]
                });

            $(idToShow).removeClass("hidden");
            setTimeout(() => {
                $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
            }, 100);
    }
    else
    {
        var feeding_products = document.querySelector( idToShow );
        $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
        $(idToShow).removeClass("hidden");
            // for (let i = 0; i < feeding_products.length; i++) {
            //     const feeding_product_option = feeding_products[i];

            // }
    }

}



function handleLayerChoice(e)
{
    var idStr = $(e).closest(".active-feeding-calc-layer").attr("id");

    if ( idStr == undefined )
    {
      // don't like multiple return paths, but this routine is a mess anyway
      return;
    }
    var parentLayer = idStr.slice(-1);
    var nextParent = parseInt(parentLayer) + 1;

    if( e.dataset?.mix == "mix" )
    {
        isProductAdded.wet = false;
        isProductAdded.dry = false;
    }
    if(e.value == "cat" || e.value == "dog")
    {
        dogCatSelection = e.value;
        $("#feeding-calc-cat-dog-banner").addClass("hidden");
        var id = "#feeding-calc-" + e.value + "-banner";
        $(id).removeClass("hidden");
        SpecialiseCalculatorForPetType( e.value );
    }
    else if(e.value == "wet" || e.value == "dry")
    {
        wetDrySelection = e.value;
        document.getElementById("mix_ratio").value = "";
    }
    else if(e.value?.includes("mix"))
    {
        wetDrySelection = e.value;

        if( e.value == "mix")
        {
            document.getElementById( "feeding-calc-custom-mix-container" ).classList.add( 'active' );
            return;
        }
        else
        {
            document.getElementById("mix_ratio").value = e.value;
        }
    }
    else
    {
        // document.getElementById( "feeding-calc-custom-mix-container" ).style.maxHeight = 'initial';
        if(e.value)
        {
            var idToShow = "#feeding-calc-option-row-options-wet-" + dogCatSelection;
            document.querySelector(idToShow).classList.remove( 'hidden' );
            if(e.value.includes("mix_"))
            { 
                document.getElementById("mix_ratio").value = e.value.replace('mix_','');
            }
            else
            {
                document.getElementById("mix_ratio").value = "";
            }
        }

        productSelection = e.getAttribute( "data-pid" );

        SpecialiseCalculatorForProduct( e );

        if ( dogCatSelection == "dog" )
        {
            document.getElementById( "standalone-feeding-calculator-dog-questions" ).classList.remove( "hidden" );
            document.getElementById( "standalone-feeding-calculator-cat-questions" ).classList.add( "hidden" );
        }
        else if( dogCatSelection == "cat" )
        {
            document.getElementById( "standalone-feeding-calculator-dog-questions" ).classList.add( "hidden" );
            document.getElementById( "standalone-feeding-calculator-cat-questions" ).classList.remove( "hidden" );
        }
    }

    if(nextParent == 4)
    {
        $( '.layer_4 .feeding-calc-option-row-options' ).addClass("hidden");
        var idToShow = "#feeding-calc-option-row-options-" + wetDrySelection + "-" + dogCatSelection;

        if (idToShow.includes('mix')) 
        {
            idToShow = "#feeding-calc-option-row-options-wet-" + dogCatSelection;
        }

        var product_count = $( idToShow + ' .calculator_product_selector' ).length;
        
        if (product_count > 1) 
        {
            var slider = $(idToShow);
          
            if( slider.hasClass("slick-initialized") )
            {
                slider.removeClass("hidden");
                slider.slick( "unslick");
            }
            
            {
                //if( $(idToShow).hasClass( "slick-initialized" ) == false )
                {
                    slider.slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false,
                        swipeToSlide:true,
                        arrows: true,
                        // centerMode: true,
                        autoplay: false,
                        nextArrow: '<button class="next"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                        '<path d="M100.707 8.45711C101.098 8.06658 101.098 7.43342 100.707 7.04289L94.3431 0.678932C93.9526 0.288408 93.3195 0.288408 92.9289 0.678932C92.5384 1.06946 92.5384 1.70262 92.9289 2.09315L98.5858 7.75L92.9289 13.4069C92.5384 13.7974 92.5384 14.4305 92.9289 14.8211C93.3195 15.2116 93.9526 15.2116 94.3431 14.8211L100.707 8.45711ZM0 8.75H100V6.75H0V8.75Z" fill="#8D3F2B"/>'+
                        '</svg></button>',
                        prevArrow: '<button class="prev"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                        '<path d="M0.292892 7.04289C-0.0976334 7.43342 -0.0976334 8.06658 0.292892 8.45711L6.65685 14.8211C7.04738 15.2116 7.68054 15.2116 8.07107 14.8211C8.46159 14.4305 8.46159 13.7974 8.07107 13.4069L2.41422 7.75L8.07107 2.09315C8.46159 1.70262 8.46159 1.06946 8.07107 0.678932C7.68054 0.288408 7.04738 0.288408 6.65685 0.678932L0.292892 7.04289ZM101 6.75L1 6.75V8.75L101 8.75V6.75Z" fill="#8D3F2B"/>'+
                        '</svg></button>',
                        responsive: [
                            {
                              breakpoint: 1024,
                              settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                              }
                            },
                            {
                              breakpoint: 768,
                              settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                              }
                            },
                            {
                              breakpoint: 480,
                              settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                              }
                            }
                        ]
                    });
                }

                $(idToShow).removeClass("hidden");
                setTimeout(() =>
                {
                    $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
                    ReslickVisibleProductSlider( );
                }, 10);
            }
        }
        else
        {
            var feeding_products = document.querySelector( idToShow );
            $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
            $(idToShow).removeClass("hidden");
            // for (let i = 0; i < feeding_products.length; i++) {
            //     const feeding_product_option = feeding_products[i];
                
            // }
        }
    }
    else
    {
        console.log( "............................................ HERE !!! nextParent: " + nextParent )
    }


    if ( nextParent == 5 ) 
    {
        var button = document.querySelector( "#startMixCalc" );
        if( !wetDrySelection.includes( "mix" ) )
        {
            button.textContent = "Like to mix wet & dry?";
            button.setAttribute( "data-go_to", "layer_3" );
            button.style.display = "block";
        }
        else
        {
            button.textContent = "Continue to dry >>>";
            button.setAttribute( "data-go_to", "layer_4" );
        }
        // document.getElementById( "feeding-calc-layer-3-inner" ).classList.remove( 'active' );
        // document.getElementById( "feeding-calc-layer-3-inner" ).classList.add( 'hidden' );

        // document.getElementById( "feeding-calc-custom-mix-container" ).classList.remove( 'hidden' );
        // document.getElementById( "feeding-calc-custom-mix-container" ).classList.add( 'active' );

        // document.getElementById( "feeding-calc-custom-mix-ranger-id" ).classList.remove( 'hidden' );
        // document.getElementById( "feeding-calc-custom-mix-ranger-id" ).classList.add( 'active' );
    }

    if( e.value == "mix_custom" )
    {
        document.getElementById("mix_ratio").value = "0/100";
        document.getElementById( "feeding-calc-layer-3-inner" ).classList.remove( 'active' );
        document.getElementById( "feeding-calc-layer-3-inner" ).classList.add( 'hidden' );
        document.getElementById( "feeding-calc-custom-mix-ranger-id" ).classList.remove( 'hidden' );
        document.getElementById( "feeding-calc-custom-mix-ranger-id" ).classList.add( 'active' );
        document.querySelector( "#feeding-calc-layer-3 .range_navigationButton" ).setAttribute("data-go_to", "food_type");
        document.querySelector( "#feeding-calc-layer-3 .range_navigationButton" ).style.margin = "10px 0 0";
    }
    else
    {
        
        $(".active-feeding-calc-layer").removeClass("active-feeding-calc-layer");
    
        $("#feeding-calc-layer-" + nextParent).addClass("active-feeding-calc-layer");
    }
}

function showSliderValue() {
    const slider_input = document.getElementById('slider_input');
    const slider_thumb = document.getElementById('slider_thumb');
    const updated_count = document.getElementById('updated_count');
    const slider_line = document.getElementById('slider_line');
    
    const sliderRemainingValue = slider_input.max - slider_input.value;

    updated_count.innerHTML = slider_input.value +'/' + sliderRemainingValue;
    const bulletPosition = slider_input.value / slider_input.max;
    const space = slider_input.offsetWidth - slider_thumb.offsetWidth;

    slider_thumb.style.left = (bulletPosition * space) + 'px';
    slider_line.style.width = slider_input.value + '%';

    document.getElementById("mix_ratio").value = slider_input.value +'/' + sliderRemainingValue;
}

function WetDryMixSelection( element ) 
{
    var done = true;
    
    /* check if user selected 'mix' option or not. 
    if yes, send them to dry products selection */
    if (wetDrySelection.includes('mix') &&  isProductAdded.wet == false) 
    {
        isProductAdded.wet = true;

        var startMixCalc_button = document.querySelector( '#startMixCalc' ).style.display = "block";
        var idToShow = "#feeding-calc-option-row-options-dry-" + dogCatSelection;
        var idToHide = "#feeding-calc-option-row-options-wet-" + dogCatSelection;
        $(idToHide).addClass( 'hidden' );
        
        var product_count = $( idToShow + ' .calculator_product_selector' ).length;

        if (product_count > 0) 
        {
            done = false;
            
            if( $(idToShow).hasClass("slick-initialized") )
            {
                $(idToShow).removeClass("hidden");
                $(idToShow).slick( "unslick");

            }
            
            {
                $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
                $(idToShow).removeClass("hidden");

                if( $(idToShow).hasClass( "slick-initialized" ) == false )
                {
                    $(idToShow).slick({
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false,
                        swipeToSlide:true,
                        arrows: true,
                        // centerMode: true,
                        autoplay: false,
                        nextArrow: '<button class="next"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                        '<path d="M100.707 8.45711C101.098 8.06658 101.098 7.43342 100.707 7.04289L94.3431 0.678932C93.9526 0.288408 93.3195 0.288408 92.9289 0.678932C92.5384 1.06946 92.5384 1.70262 92.9289 2.09315L98.5858 7.75L92.9289 13.4069C92.5384 13.7974 92.5384 14.4305 92.9289 14.8211C93.3195 15.2116 93.9526 15.2116 94.3431 14.8211L100.707 8.45711ZM0 8.75H100V6.75H0V8.75Z" fill="#8D3F2B"/>'+
                        '</svg></button>',
                        prevArrow: '<button class="prev"><svg width="101" height="16" viewBox="0 0 101 16" fill="none" xmlns="http://www.w3.org/2000/svg">'+
                        '<path d="M0.292892 7.04289C-0.0976334 7.43342 -0.0976334 8.06658 0.292892 8.45711L6.65685 14.8211C7.04738 15.2116 7.68054 15.2116 8.07107 14.8211C8.46159 14.4305 8.46159 13.7974 8.07107 13.4069L2.41422 7.75L8.07107 2.09315C8.46159 1.70262 8.46159 1.06946 8.07107 0.678932C7.68054 0.288408 7.04738 0.288408 6.65685 0.678932L0.292892 7.04289ZM101 6.75L1 6.75V8.75L101 8.75V6.75Z" fill="#8D3F2B"/>'+
                        '</svg></button>',
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                slidesToShow: 3,
                                slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                                }
                            }
                        ]
                    });
                }

                //$(idToShow).removeClass("hidden");
                //setTimeout(() => {
                //    $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
                //}, 100);
            }
        }
        else
        {
            $(idToShow + (" .calculator_product_selector")).css("visibility", "visible");
            $(idToShow).removeClass("hidden");
        }

    }
    else if (wetDrySelection.includes('mix') &&  isProductAdded.dry == false) 
    {
        isProductAdded.dry = true;

        if (wetDrySelection.includes('mix') &&  isProductAdded.dry == true && isProductAdded.wet == true )
        {
            var startMixCalc_button = document.querySelector( '#startMixCalc' ).style.display = "none";
        }
    }

    return ( done );
}


function getCurrentMix()
{
    var currentMix = null;
    var mixVal = document.getElementById("mix_ratio").value;
    if(mixVal == "")
    {
        currentMix = null;
    }
    else if ( mixVal.indexOf( "_" ) > 0 )
    {
        currentMix = mixVal.split( "_" )[ 1 ];
    }
    else
    {
        currentMix = mixVal;
    }
    return ( currentMix );
}

function ActualCalorieCalculation( category, weight, rerMultiplier, activityLevel )
{
    var selector;
    if ( ( category == "cat" ) || ( category == "kitten" ) )
    {
        selector = "#standalone-feeding-calculator-cat-questions";
    }
    else if ( ( category == "dog" ) || ( category == "puppy" ) )
    {
        selector = "#standalone-feeding-calculator-dog-questions";
    }

    var x;
    var age = parseFloat($(selector + ' select[name="age"]').find(":selected").val());
    x = ( ( Math.pow( weight, rerMultiplier ) *  age * activityLevel ) );

    if ( ( category == "kitten" ) || ( category == "puppy" ) )
    {
        x = x / 0.9;
    }

    return x;
}

// this returns grams ! not calories !!
function calorieCalculation(category, weight, rerMultiplier, activityLevel, calDensity)
{
    if( category == "cat" || category == "kitten" )
    {
        var selector = "#standalone-feeding-calculator-cat-questions";
    }
    if( category == "dog" || category == "puppy" )
    {
        var selector = "#standalone-feeding-calculator-dog-questions";
    }

    var x;
    var age = parseFloat($(selector + ' select[name="age"]').find(":selected").val());
    var ageText = $(selector + ' select[name="age"]').find(":selected").attr("data-age");
    if( ageText.includes("months") )
    {
        ageText = ageText.split(" ")[0];
        ageMin = ageText.split("-")[0];
        ageMax = ageText.split("-")[1];
        if( category == "cat" )
        {
            var ageLimit = $('.feeding_calculator_wrapper').attr('data-kitten-age');
        }
        else if( category == "dog" )
        {
            var ageLimit = $('.feeding_calculator_wrapper').attr('data-puppy-age');
        }
        if( ageLimit <= ageMax || ageMin < ageLimit )
        {
            activityLevel = $('.feeding_calculator_wrapper').attr('data-kitten-puppy-activity');
        }
    }
    x = ((Math.pow( weight, rerMultiplier ) *  age * activityLevel) / calDensity);

    return x;
}

function GetMultiplier( category )
{
    var multiplier;

    if ( category == "cat" )
    {
        multiplier = 0.711;
    }
    else if(category == "kitten")
    {        
        multiplier = 0.67;
    }
    else if ( category == "dog" )
    {
        multiplier = 0.75;
    }
    else if ( category == "puppy" )
    {
        multiplier = 0.75;
    }
    return ( multiplier );
}

function ReallyRunFeedingCalulation(weight,category,isTreats,activityLevel,calDensity)
{   
    var grams;

    if(category == "cat")
    {
        if(isTreats == false)
        {
            grams = calorieCalculation(category,weight,0.711,activityLevel,calDensity);
        }
        else if( isTreats )
        {
            grams = calorieCalculation(category,weight,0.711,activityLevel,calDensity)*0.9;
        }
    }
    else if(category == "kitten")
    {        
        grams = calorieCalculation(category,weight,0.67,activityLevel,calDensity)/0.9;
    }
    else if(category == "dog")
    {
        if(isTreats == false)
        {
            grams = calorieCalculation(category,weight,0.75,activityLevel,calDensity);

        }
        else if( isTreats )
        {
            grams = calorieCalculation(category,weight,0.75,activityLevel,calDensity)*0.9;
        }
    }
    else if (category == "puppy")
    {
        grams = calorieCalculation(category,weight,0.75,activityLevel,calDensity)/0.9;
    }

    grams = Math.round(grams);

    return grams;
}

function HandleDaysPositioning()
{
    var secondInput = document.querySelector('.product_data_inner-second');
    var daysContainers = document.querySelectorAll( '.last_day_content_wraper' );

    if( daysContainers && daysContainers.length > 0 )
    {
        if( secondInput )
        {
            if( window.innerWidth > 1150 )
            {
                daysContainers.forEach( function( container ) 
                {
                    var parent = container.closest( '.product_data_inner' );
                    var sub_box = parent.querySelector( '.subscription_box' );
                    parent.insertBefore( container, sub_box );
                });
            }
            else if( window.innerWidth < 768 && window.innerWidth > 550 )
            {
                daysContainers.forEach( function( container ) 
                {
                    var parent = container.closest( '.product_data_inner' );
                    var content_box = parent.querySelector( '.product_content' );
                    content_box.appendChild( container );
                });
            }
            else
            {
                daysContainers.forEach( function( container ) 
                {
                    var parent = container.closest( '.product_data_inner' );
                    var sub_box = parent.querySelector( '.subscription_box' );
                    parent.insertBefore( container, sub_box );
                });
            }
        }
        else
        {
            daysContainers.forEach( function( container ) 
            {
                var parent = container.closest( '.product_data_inner' );
                var content_box = parent.querySelector( '.product_content' );
                content_box.appendChild( container );
            });
        }
    }
}

function RunMixFeedCalculation( mixWet, mixDry, weight, category, isTreats, activityLevel, dryDensityParam )
{
    var firstInput = document.querySelector( 'input[name="flavourCaloriesMixFirst"]' );
    document.querySelector( ".mix-product-1" ).innerHTML = firstInput._productData.title;
    var secondInput = document.querySelector( 'input[name="flavourCalories"]' );
    document.querySelector( ".mix-product-2" ).innerHTML = secondInput._productData.title;

    var dryDensity = Number( dryDensityParam );
    var multiplier = GetMultiplier( category );
    var calories   = ActualCalorieCalculation( category, weight, multiplier, activityLevel );
    var ratio      = mixWet / mixDry;
    var wetDensity = Number( document.querySelector( "input[name='flavourCaloriesMixFirst']" ).value );
    var wetGrams   = calories / ( dryDensity + ( wetDensity * ratio ) );
    var dryGrams   = wetGrams * ratio;

    console.log( "wet/dry ratio " + mixWet + "/" + mixDry + " gives wet : " + wetGrams + ", dry : " + dryGrams );

    $('input[name="grams"]').val( parseInt( Math.round( dryGrams ) ) + " G" );
    $('input[name="wetGrams"]').val( parseInt( Math.round( wetGrams ) ) + " G" );

    var wrapper = document.querySelector( ".product_data_inner-wrapper" );
    $( ".calculator_build_basket_button" ).off( ).on( "click", function( )
    {
        wrapper.removeAttribute( "style" );
        document.querySelector( ".calculator_build_basket_button" ).setAttribute( "style", "display: none;" );
    } );

    var first  = wrapper.querySelector( ".product_data_inner:not( .product_data_inner-second )" );
    var second = wrapper.querySelector( ".product_data_inner-second" );
    if ( !second )
    {
        second = wrapper.querySelector( ".product_data_inner" ).cloneNode( true );
        second.classList.add( "product_data_inner-second" );
        wrapper.insertBefore( second, wrapper.firstElementChild );
    }
    SetupProduct( second, secondInput._productData );
    SetupProduct( first, firstInput._productData );

    HandleDaysPositioning();
}

function TestMixFeedCalculation( )
{
    var testDryProduct = g_feedingCalculatorProducts[ 12 ]; // chicken dry cat food
    var testWetProduct = g_feedingCalculatorProducts[ 15 ]; // chicken in jelly wet cat food
    var category       = "cat";
    var ageIndex       = 3;
    var weight         = 2;
    var activity       = 150;  // 150 outdoor, 100 indoor

    // set up ui stuff used by calculation (todo : fix this !)
    document.querySelector( 'input[name="flavourCaloriesMixFirst"]' ).value        = testWetProduct.calorieDensity;
    document.querySelector( 'input[name="flavourCaloriesMixFirst"]' )._productData = testWetProduct;
    document.querySelector( 'input[name="flavourCalories"]' ).value                = testDryProduct.calorieDensity;
    document.querySelector( 'input[name="flavourCalories"]' )._productData         = testDryProduct;
    if ( ( category == "cat" ) || ( category == "kitten" ) )
    {
        selector = "#standalone-feeding-calculator-cat-questions";
    }
    else if ( ( category == "dog" ) || ( category == "puppy" ) )
    {
        selector = "#standalone-feeding-calculator-dog-questions";
    }
    var element = document.querySelector( selector + " select[name='age']" );
    element.selectedIndex = ageIndex;

    RunMixFeedCalculation( 20, 80, weight, category, false, activity, testDryProduct.calorieDensity );
    RunMixFeedCalculation( 60, 40, weight, category, false, activity, testDryProduct.calorieDensity );
    RunMixFeedCalculation( 50, 50, weight, category, false, activity, testDryProduct.calorieDensity );
}

function calculateAmt()
{
    var weightElement   = document.querySelector( ".select_weight:not( .hidden * )" );
    var weight          = weightElement.value;
    var container       = weightElement.closest( ".scrumbles-sub-content-row-desktop" ).parentNode;
    var category        = $('input[name="foodCategory"]').val();
    var treatBox        = container.querySelector( '.treats-container input' );
    var isTreats        = treatBox.checked;
    var activityElement = container.querySelector( '.pet_block_option.active input' );
    var activityLevel   = activityElement.value;
    var calDensity      = $('input[name="flavourCalories"]').val();
    var calcResult      = ReallyRunFeedingCalulation( weight, category, isTreats, activityLevel, calDensity );
    var grams           = ( Math.round( calcResult* 10 ) / 10 );
    var container       = document.querySelector( ".product_data" );
    var currentMix      = getCurrentMix();
    var isMixCalc       = false;

    if ( currentMix != null )
    {
        var mixWet = currentMix.split("/")[0] / 100;
        var mixDry = currentMix.split("/")[1] / 100;

        if ( ( mixWet > 0 ) && ( mixDry > 0 ) )
        {
            isMixCalc = true;
        }
    }
    document.querySelector( ".calculator_build_basket_button" ).removeAttribute( "style" );
    if ( isMixCalc )
    {
        container.classList.add( "product-data-mixed-results" );
        var mixResult = RunMixFeedCalculation( mixWet, mixDry, weight, category, isTreats, activityLevel, calDensity );
        document.querySelector( ".product_data_inner-wrapper" ).setAttribute( "style", "display: none;" );
    }
    else
    {
        var second = container.querySelector( ".product_data_inner-second" );
        if ( second )
        {
            second.remove( );
        }
        
        document.querySelector( ".product_data_inner-wrapper" ).removeAttribute( "style" );
        container.classList.remove( "product-data-mixed-results" );
        $('input[name="grams"]').val( parseInt( Math.round( grams ) ) );

        HandleDaysPositioning();
    }    
}

function ReallySetBagTime(select)
{
    console.log("selector")
    console.log(select)
    var selected        = $( select ).prop( "selectedOptions" )[ 0 ];
    if( selected )
    {
        var variantData     = JSON.parse( selected.getAttribute( "data-variant-data" ) );
        var variantTitle    = variantData.title.toLowerCase();
    
        var grams           = $('input[name="grams"]').val().split( " " )[ 0 ];
        
        var bagWeight       = 0;
    
        if( variantTitle.includes( "kg" ) )
        {
            bagWeight = variantTitle.replace( "kg", "" );
            bagWeight   = Number( bagWeight )*1000;
            var days    = (bagWeight / grams);
        }
        else if( variantTitle.includes( "g" ) && variantTitle.includes( "x" ) )
        {
            var bagMulti = variantTitle.split(" - ")[0];
            var amtBags = bagMulti.split("x")[0];
            var amtPerBag = bagMulti.split("x")[1].replace("g", "");
    
            bagWeight = amtBags*amtPerBag;
            // bagWeight   = Number( bagWeight )*1000;
            var days    = (bagWeight / grams);
    
        }
        else if(variantTitle.includes( "g" ) && !variantTitle.includes( "x" ))
        {
            bagWeight = variantTitle.replace( "g", "" );
            bagWeight   = Number( bagWeight ) * 1000;
            var days    = (bagWeight / grams)/1000;
        }
    
        // $( 'input[name="day"]' ).val( Math.round( days ) );
        var parentBox = select.closest('.product_data_inner');
        parentBox.querySelector('input[name="day"]').value = Math.round( days );

        var days = Math.round( days );
        var weeks = Math.floor( days / 7 );
        var frequencySelect = parentBox.querySelector( '.selling_plan_all_groups' );
        var weeksMatched = false;
        for( index in frequencySelect.options )
        {
            if( index > 0 )
            {
                var planWeeks = frequencySelect.options[ index ]?.getAttribute( "data-plan-weeks" );
                if( planWeeks && planWeeks == weeks )
                {
                    frequencySelect.selectedIndex = Number(index);
                    weeksMatched = true;
                }
                if( index == frequencySelect.options.length-1 && weeksMatched == false )
                {
                    var minWeek = Number(frequencySelect.options[ 1 ].getAttribute( "data-plan-weeks" ));
                    var maxWeek = Number(frequencySelect.options[ frequencySelect.options.length-1 ].getAttribute( "data-plan-weeks" ));
                    if( weeks < minWeek )
                    {
                        frequencySelect.selectedIndex = 1;
                    }
                    else if( weeks > maxWeek )
                    {
                        frequencySelect.selectedIndex = frequencySelect.options.length-1;
                    }
                }
            }
        }

        // var frequency = frequencySelect.options[ frequencySelect.selectedIndex ].dataset.planName;
        // if( frequency.includes( "weeks" ) )
        // {
        //     frequency = frequency.split( " " )[ 1 ];
        //     frequencyDays
        // }

        if( variantData.available == false )
        {
            parentBox.querySelector(".product_data .subscription_box").style.display = "none";
            parentBox.querySelector(".product_data .calculator_atc_button").setAttribute( "disabled", "disabled" );
            parentBox.querySelector(".product_data .calculator_atc_button").textContent = "Sold out";
        }
        else
        {
            parentBox.querySelector(".product_data .subscription_box").style.display = "block";
            parentBox.querySelector(".product_data .calculator_atc_button").removeAttribute( "disabled" );
            parentBox.querySelector(".product_data .calculator_atc_button").textContent = "Add to cart";
        }
    }
}

function SetBagTime()
{
    console.log("SetBagTime");
    var feedingCalcProductSelectors = document.querySelectorAll( ".pet_food_calculation .variant_list select" );
    if( !feedingCalcProductSelectors )
    {
        feedingCalcProductSelectors = document.querySelectorAll(".single_product_data .product__variant--dropdown");
    }
    feedingCalcProductSelectors.forEach( function( feedingCalcProductSelector )
    {
        ReallySetBagTime( feedingCalcProductSelector );
    });
}

function assignRatios(RER,wetGrams,dryGrams)
{
    console.log("Start Mixing /////");
    var rows = document.querySelectorAll(".food_table tbody tr")

    var calorieTexts = document.querySelectorAll(".calories")

    for(var x = 0; x < calorieTexts.length; x++)
    {
        calorieTexts[0].innerText = Math.round((RER * 10) / 10)
        
    }

    console.log("wet Grams: " + wetGrams)
    console.log("dry Grams: " + dryGrams)
    
    for(var i = 0; i < rows.length; i++)
    {
        var row = rows[i];
        var cells = row.querySelectorAll("td");
        var ratio = row.getAttribute("ratio").split("/");
        var wetAmt = parseInt(ratio[0])/100;
        var dryAmt = parseInt(ratio[1])/100;

        cells[1].textContent = Math.round((wetGrams*wetAmt * 10) / 10)
        cells[2].textContent = Math.round((dryGrams*dryAmt * 10) / 10)

    }
    console.log("End Mixing /////");
}

function calculateMix()
{
    var weightElement = document.querySelector( ".select_weight:not( .hidden * )" );
    var weight        = weightElement.value;
    var container     = weightElement.closest( ".scrumbles-sub-content-row-desktop" ).parentNode;    
    var type          = $('input[name="foodType"]').val();
    var category      = $('input[name="foodCategory"]').val();
    var activityLevel = container.querySelector( '.pet_block_option.active input' ).value;
    var calDensity       = $('input[name="flavourCalories"]').val();
    var defaultCal,dryAmt,wetAmt,RER;

    if(type == "dry")
    {
        dryAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,calDensity);
        console.log("Dry = " + dryAmt);
        defaultCal = $('input[name="deafultWet"]').val();
        console.log("Default wet density: " + defaultCal);
        wetAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,defaultCal);
        console.log("Wet = " + dryAmt);

        

        RER = dryAmt * calDensity;
        assignRatios(RER,wetAmt,dryAmt);
    }
    else if(type == "wet")
    {
        wetAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,calDensity);
        defaultCal = $('input[name="deafultDry"]').val();
        console.log("Default dry density: " + defaultCal);
        dryAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,defaultCal);
        
        RER = wetAmt * calDensity;
        assignRatios(RER,wetAmt,dryAmt);
    }

}

function setSellingplan_price() 
{
    var selectElement           = document.querySelector( ".variant_list select" );
    var onetime_priceElement    = document.querySelector( ".onetime_price" );
    var subSave_priceElement    = document.querySelector( ".subSave_price" );
  
    function updatePrices() 
    {
      var selectedOption = selectElement.options[ selectElement.selectedIndex ];
      if ( selectedOption && onetime_priceElement && subSave_priceElement )
      {
          onetime_priceElement.innerText = theme.Currency.formatMoney( selectedOption.getAttribute( "data-originalprice" ) );
          subSave_priceElement.innerText = theme.Currency.formatMoney( selectedOption.getAttribute( "data-subsave_price" ) );
      }
    }
  
    selectElement.addEventListener( "change", updatePrices );
    updatePrices();

    var observer = new MutationObserver(function (ml, o)
    {
        observer.disconnect( );
        observer.takeRecords( );

        updatePrices();
        
        observer.observe( selectElement, { "childList": true, "subtree": true } );
    } );
    observer.observe( selectElement, { "childList": true, "subtree": true } );
}

function Subscriptionvalidation( parent )
{
    var result          = true;
    var alloptions      = parent.querySelector( '.alloptions' );
    var weekSelectBox   = parent.querySelector( '.selling_plan_all_groups' );
    var selected_value  = weekSelectBox.options[ weekSelectBox.selectedIndex ].value;

    if ( selected_value == '' ) 
    {
        result = false;
        
        weekSelectBox.classList.add("error");
        alloptions.innerHTML += "<p class='error_message'>Please select frequency.</p>";

        setTimeout(() => 
        {
            var error_message = alloptions.querySelector( '.error_message' );
            if ( error_message ) 
            {           
                weekSelectBox.classList.remove( "error" ); 
                error_message.remove( );
            }

        }, 3000);
    }

    return ( result );
}

function PFC_ajaxifyAddtocart( event ) 
{
    var parent = event.currentTarget.closest('.product_data_inner');
    if ( ( parent.querySelector( ".option__onetime" ).classList.contains( "option--active" ) ) || ( Subscriptionvalidation( parent ) ) )
    {
        var variantId = $( parent ).find( '.variant_list select' ).val();

        // Create the data object in the expected format
        var data;
        if ( $( ".option__subSave.option--active", $( parent ) ).length > 0 ) 
        {
            let selling_select = parent.querySelector( '.selling_plan_all_groups' );
            let sellingPlanId = selling_select.options[ selling_select.selectedIndex ].value;
            if ( sellingPlanId != '' ) 
            {                
                data = 
                {
                    id: variantId,
                    selling_plan: sellingPlanId,
                    quantity: 1
                };
            }
        }
        else
        {
            data = 
            {
                id: variantId,
                quantity: 1
            };
        }

        $.ajax(
        {
            url: '/cart/add.js',
            type: 'POST',
            headers: 
            {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify( data ),
            success: function () 
            {
                var popup = document.querySelector( ".cart-added-pop-up" );

                popup.querySelector( ".cart-added-popup-title" ).innerHTML = parent.querySelector( ".product_title" ).innerHTML;
                    
                document.dispatchEvent( new CustomEvent( 'ajaxProduct:added' ) );
                popup.style.top = "15%";
                popup.style.display = "block";

                setTimeout( function () 
                {
                    popup.style.display = "none";
                    popup.style.top = "25%";

                }, 5000 );
            }
        } );
    }
}

window.addEventListener("DOMContentLoaded", function()
{
    var dragmovement = 0;
    $(".final_calc_button").click(function(e)
    {
        if ( WetDryMixSelection( e ) )
        {
            var productData = GetProductData( e.currentTarget );
            if ( productData )
            {
                var element = document.querySelector( 'input[name="flavourCalories"]' );
                element.value = productData.calorieDensity;
                element._productData = productData;
            }

            if(dragmovement <= 10){
                handleLayerChoice( e.currentTarget );
            }
            console.log("done");
            //WetDryMixSelection( e );

            $(".slide_1").addClass("active");
            calculateAmt();
            SetBagTime();
            //calculateMix();
        }
        else
        {
            var productData = GetProductData( e.currentTarget );
            if ( productData )
            {
                var element = document.querySelector( 'input[name="flavourCaloriesMixFirst"]' );
                element.value = productData.calorieDensity;
                element._productData = productData;
            }
        }
        var selectors = document.querySelectorAll(".variant_list select");

        selectors.forEach( function( selector )
        {
            selector.addEventListener("change", function(e)
            {
                ReallySetBagTime( e.currentTarget );
            } );
        })

        var containers = document.querySelectorAll( '.subscription_box' );
        containers.forEach( function( container )
        {
            var subscription_boxes = container.querySelectorAll( '.subscription_box input.selling_plan_radio' );
            subscription_boxes.forEach( function( subscription_box )
            {
                subscription_box.addEventListener( 'change', listenSubscriptionButton );
            });
        });

        var buttons = document.querySelectorAll( '.product_data .calculator_atc_button' );
        buttons.forEach( function( button )
        {
            button.addEventListener( 'click', PFC_ajaxifyAddtocart );
        });
    })
    $('.final_calc_button').mousedown(function(e)
    {
        dragmovement = 0;
        $(document).mousemove(function(){
            dragmovement++;
        });
    }).mouseup(function()
    {
        $(document).unbind('mousemove');
    });

    showSliderValue();
    window.addEventListener("resize",showSliderValue);
    window.addEventListener("resize",HandleDaysPositioning);
    const slider_input = document.getElementById('slider_input');
    slider_input.addEventListener('input', showSliderValue, false);
})

document.addEventListener('DOMContentLoaded', () => 
{ 
    var pbos = document.querySelectorAll( '.pet_block_option' );
    pbos.forEach( function( pbo )
    {
        listenOptionChange( pbo );
    });

    listenSlideNavigationButton();
    setSellingplan_price();

    // PFC == product feeding calculator Ajax
})
